import keyBy from 'lodash/keyBy';

import {acceptedFileTypes} from 'utils/media-utils';

export const ALLOW_VIDEOS = true;

export const ALLOWED_FILE_TYPES = acceptedFileTypes;

export const READY_STATE = keyBy(['EMPTY', 'LOADING', 'DONE']);
